export default __webpack_public_path__ + "static/media/VicenteUrruticoechea.4963bf4d.png";